import { createSlice } from "@reduxjs/toolkit";

const timer = createSlice({
  name: "timer",
  initialState: {
    testDuration: 0,
    timeTaken: 0,
  },
  reducers: {

    updateTestDuration: (state, action) => {
      state.testDuration = action.payload;
    },

    updateTimeTaken: (state, action) => {
      state.timeTaken = action.payload;
    },
  },
});

export const {
  updateTestDuration,
  updateTimeTaken,
} = timer.actions;

export default timer.reducer;
